import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface WeeklyHoursReportSummary {
  id: number;
  etablissementId: number;
  etablissementName: string;
  agencyId?: number;
  weekNumber: number;
  year: number;
  weekStart: string;
  weekEnd: string;
  status: 'DRAFT' | 'READY' | 'SENT';
  sentAt?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
  allowedSendFrom?: string;
  canSendNow?: boolean;
}

export interface WeeklyHoursReportLine {
  id: number;
  missionId: number;
  missionRef?: string;
  candidatId: number;
  candidatFullname: string;
  weekNumber?: number;
  startDate: string;
  endDate: string;
  startTime: string | null;
  endTime: string | null;
  pauseMinutes?: number | null;
  totalHours?: number | null;
  lineState: 'EN_COURS' | 'ACHEVE' | 'ANNULE';
  observations?: string;
  edited?: boolean;
}

export interface WeeklyHoursReportDetail extends WeeklyHoursReportSummary {
  lines: WeeklyHoursReportLine[];
}

@Injectable({ providedIn: 'root' })
export class WeeklyHoursService {
  private base = `${environment.api.BASE_URL}/api/agency/weekly-hours`;

  constructor(private http: HttpClient) {}

  list(): Observable<WeeklyHoursReportSummary[]> {
    return this.http.get<WeeklyHoursReportSummary[]>(this.base);
  }

  get(id: number): Observable<WeeklyHoursReportDetail> {
    return this.http.get<WeeklyHoursReportDetail>(`${this.base}/${id}`);
  }

  updateLine(reportId: number, lineId: number, edits: Partial<WeeklyHoursReportLine>): Observable<WeeklyHoursReportLine> {
    return this.http.put<WeeklyHoursReportLine>(`${this.base}/${reportId}/line/${lineId}`, edits);
  }

  regenerate(reportId: number): Observable<WeeklyHoursReportDetail> {
    return this.http.post<WeeklyHoursReportDetail>(`${this.base}/${reportId}/regenerate`, {});
  }

  pdf(reportId: number): Observable<{ contractBytes: string }> {
    return this.http.get<{ contractBytes: string }>(`${this.base}/${reportId}/pdf`);
  }

  send(reportId: number): Observable<{ status: string; sentAt: string }> {
    return this.http.post<{ status: string; sentAt: string }>(`${this.base}/${reportId}/send`, {});
  }
}
